import React from 'react'

const Logo = ({ onLoad, className, src }) => <img className={className} onLoad={onLoad} src={src} alt='alku logo'/>

export default Logo
